import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const downloadCertificate = async (userId = "", name = "") => {
  try {
    const { data: blob } = await api.get(
      `/training/certificate${userId ? `?user_id=${encodeURIComponent(userId)}` : ""}`,
      { responseType: "blob" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `certificado-${(name || "redactor").toLowerCase().replace(/[^a-z0-9]+/g, "-")}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Certificado descargado");
  } catch (e) {
    toast.error(errMsg(e));
  }
};
